import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'antd';
import { EyeInvisibleFilled } from '@ant-design/icons';

import moment from 'moment';
import bytes from 'bytes';

import { sortMedia } from 'utils';

const formatMimeType = type => (type ? type.split('/')[1].toUpperCase() : '');
const formatTime = time => moment(time).format('MMMM Do YYYY');
const formatSize = size => bytes(size);

const MaterialMediaList = props => {
	const { event, media, library } = props;
	const eventID = event.id;
	const { sort_order } = library;
	const columns = [
		{
			title: 'Type',
			dataIndex: 'mime_type',
			key: 'mime_type',
			render: mime_type => formatMimeType(mime_type),
		},
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			render: (name, record) => {
				const breadcrumbLibrary = library.name !== 'Materials' ? library : null;
				return (
					<Link to={`/events/${eventID}/media/${record.id}`} state={{ library: breadcrumbLibrary }}>
						<div className="media-list-name">
							<p>{name}</p>
							{record.hidden ? <EyeInvisibleFilled /> : ''}
						</div>
					</Link>
				);
			},
		},
		{
			title: 'Last Updated',
			dataIndex: 'updated_at',
			key: 'last_updated',
			render: time => formatTime(time),
		},
		{
			title: 'Size',
			dataIndex: 'size',
			key: 'size',
			render: size => formatSize(size),
		},
	];

	const sortedMedia = sortMedia(media, sort_order);
	return <Table dataSource={sortedMedia} columns={columns} pagination={false} rowKey={'id'} />;
};

export default MaterialMediaList;
